__webpack_require__.p = "/sok-spo-rot-react/";